
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import { contentContext } from "../../../context/contentContext";
import tmdbApi from "../../../api/tmdbApi";
let { lambda, appname } = window.app

const BillingPage = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { setRoute } = useContext(contentContext);
    const { planId } = useParams();
    const [plans, setPlans] = useState([])
    const [user, setUser] = useState(null)
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        streetAddress1: '',
        streetAddress2: '',
        state: '',
        city: '',
        zipCode: '',
        phone: '',
        countryCode: 'IND'
    });
    const getPlans = async (planId) => {
        let planstmp = await tmdbApi.getPlans();
        planstmp = planstmp?.result?.filter(plan => plan.subscriptionplanid === planId)
        console.log(planstmp, planId)
        setPlans(planstmp || [])
    }

    const addPayment = async (params) => {
        let res = await tmdbApi.addPayment(params);
        console.log(res)
    }

    const getUser = async () => {
        let res = await tmdbApi.getUserData()
        setUser(res?.result[0]);
        setFormValues({
            firstName:res?.result[0]?.name,
            lastName: '',
            email:res?.result[0]?.emailid,
            streetAddress1: '',
            streetAddress2: '',
            state: '',
            city: '',
            zipCode: '',
            phone: '',
            countryCode: 'IND'
        })

    }
const handleNavigate=()=>{
    const planId = localStorage.getItem("subscriptionPlanId")
  if(planId && planId !== "undefined") {
    navigate("/fellowship")
  }else{
navigate("/subscription")
  }
    

}   
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        setRoute("user");
        if (planId) {
            getPlans(planId);
           
        }
         getUser()
    }, [planId]);

    const amoutFrmt = (amount) => {
        const formattedAmount = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 2,
        }).format(amount);
        return formattedAmount;
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
        validateForm()
    };

    const handleCountryCodeChange = (e) => {
        setFormValues(prev => ({ ...prev, countryCode: e.target.value }));
    };

    const validateForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formValues.firstName.trim()) errors.firstName = 'First name is required';
        if (!formValues.lastName.trim()) errors.lastName = 'Last name is required';
        if (!emailRegex.test(formValues.email)) errors.email = 'Valid email is required';
        if (!formValues.streetAddress1.trim()) errors.streetAddress1 = 'Street address is required';
        if (!formValues.city.trim()) errors.city = 'City is required';
        if (!formValues.state.trim()) errors.state = 'State is required';
        if (!formValues.zipCode.match(/^\d{6}$/)) errors.zipCode = 'Zip code must be 6 digits';
        if (!formValues.phone.match(/^\d{10}$/)) errors.phone = 'Phone number must be 10 digits';

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            let parms = {
                "amount": plans[0].price,
                "paymentMethod": "card",
                "userid": localStorage.getItem("userId"),
                "planId": plans[0].subscriptionplanid,
                "description": plans[0].description
            }
            await addPayment(parms)
            console.log("Form submitted successfully", formValues);
        } else {
            console.log("Validation failed", formErrors);
        }
    };

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
        "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
        "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
    ];
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>

            <div id="layout-wrapper">
                {/* <Header /> */}
                {/* <Sidebar /> */}

                {/* Start right Content here  */}

                <div className="main-content user-management billing-form" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Payment Page</h4>
                                        </div>

                                        <div>

                                            <button className="btn btn-primarys create-quiz-btn" id="add-user-btn" onClick={() => handleNavigate()}>
                                                Cancel
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body row col-lg-12 pt-4 billing-body" id="card-body">
                                            <div className="col-lg-6 billing-address">
                                                <h6>Billing Address</h6>
                                                <div className="row col-md-12 mt-4">
                                                    <div className="col-md-6 mb-3">
                                                        <div className="form_label" id="firstNameGroup">
                                                            <label>First Name</label>
                                                            <input type="text" name="firstName" className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`} value={formValues.firstName} onChange={handleInputChange} />
                                                            {formErrors.firstName && <small className="text-danger">{formErrors.firstName}</small>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="form_label" id="lastNameGroup">
                                                            <label>Last Name</label>
                                                            <input type="text" name="lastName" className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`} value={formValues.lastName} onChange={handleInputChange} />
                                                            {formErrors.lastName && <small className="text-danger">{formErrors.lastName}</small>}
                                                        </div></div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form_label" id="emailGroup">
                                                            <label>Email Address</label>
                                                            <input type="email" name="email" className={`form-control ${formErrors.email ? 'is-invalid' : ''}`} value={formValues.email} onChange={handleInputChange} />
                                                            {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form_label" id="st1Group">
                                                            <label>Street Address 1</label>
                                                            <input type="text" name="streetAddress1" className={`form-control ${formErrors.streetAddress1 ? 'is-invalid' : ''}`} value={formValues.streetAddress1} onChange={handleInputChange} />
                                                            {formErrors.streetAddress1 && <small className="text-danger">{formErrors.streetAddress1}</small>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form_label" id="st2Group">
                                                            <label>Street Address 2</label>
                                                            <input type="text" name="streetAddress2" className="form-control" value={formValues.streetAddress2} onChange={handleInputChange} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="form_label" id="stateGroup">

                                                            <label>State</label>
                                                            <select
                                                                name="state" className={`form-control ${formErrors.state ? 'is-invalid' : ''}`} value={formValues.state} onChange={handleInputChange}
                                                                required
                                                            >
                                                                <option value="">Select State</option>
                                                                {indianStates.sort().map((state, index) => (
                                                                    <option key={index} value={state}>
                                                                        {state}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {formErrors.state && <small className="text-danger">{formErrors.state}</small>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="form_label" id="cityGroup">

                                                            <label>City</label>
                                                            <input type="text" name="city" className={`form-control ${formErrors.city ? 'is-invalid' : ''}`} value={formValues.city} onChange={handleInputChange} />
                                                            {formErrors.city && <small className="text-danger">{formErrors.city}</small>}
                                                        </div></div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="form_label" id="zipGroup">

                                                            <label>Zip Code</label>
                                                            <input type="text" name="zipCode" maxLength="6" className={`form-control ${formErrors.zipCode ? 'is-invalid' : ''}`} value={formValues.zipCode} onChange={handleInputChange} />
                                                            {formErrors.zipCode && <small className="text-danger">{formErrors.zipCode}</small>}
                                                        </div></div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="form_label" id="zipGroup">

                                                            <label>Phone Number</label>
                                                            <input type="tel" name="phone" className={`form-control ${formErrors.phone ? 'is-invalid' : ''}`} value={formValues.phone} onChange={handleInputChange} />
                                                            {formErrors.phone && <small className="text-danger">{formErrors.phone}</small>}
                                                        </div></div>



                                                    <div className="col-lg-3">
                                                        <button className="create-quiz-btn border-0 mt-3" type="button" onClick={(e) => handleSubmit(e)}>
                                                            Submit
                                                        </button>                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-lg-6">
                                                <div className="col-lg-12 billing-address1">
                                                    <h6 className="mb-3">Billing Summary</h6>
                                                    <div className="d-flex justify-content-between align-items-center mb-1 total-amount">
                                                        <p>Total</p>
                                                        {plans.length > 0 ? <p>{amoutFrmt(plans[0]?.price)}/-</p>:<p>{amoutFrmt(localStorage.getItem("selectedCost"))}/-</p>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mt-3">
                                                    <h6 className="">Pay by scanning</h6>
                                                    <div className="col-lg-12 billing-address1 mt-3 pb-3">
                                                        {/* <p className="mb-2 text-start">Pay by scanning</p> */}
                                                        {/* <div className="d-flex justify-content-between align-items-center mb-1 total-amount">
                                                            <p>Total</p>
                                                            <p>75,000/-</p>
                                                        </div> */}
                                                        <div className="or-code">
                                                            <img src="https://www.emoderationskills.com/wp-content/uploads/2010/08/QR1.jpg" alt="" />
                                                            <p className="mb-0">QR Endtime - <span className="timer">15:00</span></p>
                                                            <div>
                                                                <div className="upi-apps">
                                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRv7C7cl9ufztQRxoH-y_biXvwoAf5bynbtnA&s" alt="" />
                                                                    <img src="https://cdn-icons-png.flaticon.com/512/6124/6124998.png" alt="" />
                                                                    <img src="https://play-lh.googleusercontent.com/IWU8HM1uQuW8wVrp6XpyOOJXvb_1tDPUDAOfkrl83RZPG9Ww3dCY9X1AV6T1atSvgXc" alt="" />
                                                                </div>
                                                                <p className="mt-2">Pay by using your trusted UPI App</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mt-3 upload-receipt">
                                                    <h6 className="">Upload Your Payment Receipt Here</h6>
                                                    <div className="col-lg-12 billing-address2">
                                                        <div className="file_upload "><span className="material-symbols-outlined icon"> upload_file </span>
                                                            <input type="file" id="file-upload" accept="image/jpeg, image/png, image/ome" className="file-input d-none" />
                                                            <label for="file-upload" className="stroke-btn btn create-quiz-btn px-3 py-2 mb-2 mb-lg-0 mt-3">Upload Image</label></div>
                                                    </div>
                                                    <div className="text-center">
                                                        <p className="mt-2">Take Screenshot of your payment & upload that image here</p>

                                                    </div>

                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* 
                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert> */}


                    {/* <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert> */}



                    {/* <Footer id="footer" /> */}
                    <footer className="text-center">
                        <p>© 2025 Dermatopathology Society of India. All rights reserved.</p>
                    </footer>
                </div>




            </div>
        </>
    );
};

export default BillingPage;
